import { useFormState } from 'react-final-form';
import { useShopConfigV2 } from '../../../hooks/shopConfig';
import { useFeatureFlags } from '../../../hooks/useFeatureFlags';
import { ListingItemType } from '../../../types/sharetribe/listing';
import { Tier } from '../../../types/shopConfig/shopConfigV2';
import { BackgroundRemovalType } from '../../../types/uploadcare/backgroundRemovalTypes';
import { Feature } from '../../../util/featureFlags';
import { useIsBackgroundRemovalType } from './useBackgroundRemovalType';

const isBackgroundRemovalEnabled = (bgRemovalType: BackgroundRemovalType, tier: string) => {
  const isForceEnabled = useFeatureFlags(Feature.BackgroundRemoval);
  const isPremium = tier === Tier.Premium;
  const isForceDisabled = bgRemovalType === BackgroundRemovalType.Disabled;

  if (isForceEnabled) {
    return true;
  }
  if (isForceDisabled) {
    return false;
  }

  return isPremium;
};

export const useIsBackgroundRemovalEnabled = () => {
  const { bgRemovalType } = useIsBackgroundRemovalType();
  const { tier } = useShopConfigV2();
  const { values } = useFormState();

  const isTradeIn = values?.itemType === ListingItemType.TradeIn;
  const isEnabled = isBackgroundRemovalEnabled(bgRemovalType, tier);

  return !isTradeIn && isEnabled;
};

// As of 7/15/2025, listing flow v2 has no trade in listings, so we can just check for premium
export const useIsBackgroundRemovalEnabledV2 = () => {
  const { bgRemovalType } = useIsBackgroundRemovalType();
  const { tier } = useShopConfigV2();

  return isBackgroundRemovalEnabled(bgRemovalType, tier);
};
